import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { CreateUserState } from './useCreateUser';
import { clientPathLabel, indexClients } from '../../../utils/clientTree';

/** Organisation and role: which client the account belongs to, and what it may do. */
export const AccessSection: React.FC<{ form: CreateUserState }> = ({ form }) => {
  const { t } = useI18n();
  const { errors, isLoading } = form;

  return (
    <section className="cu-section">
      <header className="cu-section-head">
        <h3>{t('users.create.stepAccess')}</h3>
        <p>{t('users.create.accessIntro')}</p>
      </header>

      {form.defaultClientId ? (
        <div className="cu-client-card" data-testid="cu-client-card">
          <span className="cu-client-label">{t('users.create.client')}</span>
          <strong>{form.clientName || form.defaultClientId}</strong>
        </div>
      ) : (
        <div className="cu-field">
          <label htmlFor="cu-client">{t('users.create.client')} <span className="required-asterisk">*</span></label>
          <select
            id="cu-client"
            data-testid="field-user-client"
            value={form.selectedClientId}
            onChange={(e) => { form.setSelectedClientId(e.target.value); form.clearError('client'); }}
            className={`cu-input${errors.client ? ' is-error' : ''}`}
            disabled={isLoading || form.loadingClients}
          >
            <option value="">{form.loadingClients ? t('common.loading') : t('users.create.selectClient')}</option>
            {form.availableClients.map((client) => <option key={client.id} value={client.id}>{clientPathLabel(client, indexClients(form.availableClients))}</option>)}
          </select>
          {errors.client && <span className="cu-error" role="alert">{errors.client}</span>}
        </div>
      )}

      <fieldset className="cu-roles" data-testid="field-user-role">
        <legend>{t('users.role')} <span className="required-asterisk">*</span></legend>
        <div className="cu-role-grid">
          {form.availableRoles.map((role) => (
            <label key={role.id} className={`cu-role${form.selectedRole === role.id ? ' is-selected' : ''}`} data-testid={`cu-role-${role.id}`}>
              <input type="radio" name="cu-role" value={role.id} checked={form.selectedRole === role.id} onChange={() => form.setSelectedRole(role.id)} disabled={isLoading} />
              <span className="cu-role-name">{role.name}</span>
              <span className="cu-role-desc">{form.roleDescription(role.id, role.description)}</span>
            </label>
          ))}
        </div>
      </fieldset>
    </section>
  );
};
